export default "__VITE_ASSET__BigqsPKw__"